<div class="row">
  <div class="col-sm-3">
    <ng-container>
      <div [formGroup]="formGroupSelection">
        <pas-select
          [formControl]="$any(formGroupSelection.get('formControlSelection'))"
          [options]="tvaCustomService.tableViewOptions"
          (ngModelChange)="onSelectTableView(tabViewSelection.selectedOption)"
          id="tabViewSelection"
          #tabViewSelection
          placeholder="{{ 'TABLE_VIEW_SYSTEM_DEFAULT' | translate }}"
          subLabel="{{ 'TABLE_VIEW_SELECT_LABEL' | translate }}">
          >
        </pas-select>
      </div>
    </ng-container>
  </div>
  <div class="col-sm-9"></div>
</div>
